export default __webpack_public_path__ + "static/InterDisplay-Thin-55173b04177c1dd1258dead67359580b.woff";